
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28638',
  depVersions: {
  "payments-ui-app": "static-1.28638",
  "bend-plugin-arboretum": "static-1.1985",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.508",
  "crm_data": "static-4.93136",
  "data-fetching-client": "static-1.10081",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8692",
  "foundations-components-legacy": "static-1.1717",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6033",
  "hs-test-utils": "static-1.8478",
  "hub-http": "static-1.6650",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11934",
  "I18n": "static-7.1700",
  "jasmine-runner": "static-1.6891",
  "quartz": "static-1.7619",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5640",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6071",
  "UIComponents": "static-3.8880",
  "usage-tracker-public": "static-1.7574",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38034",
  "payments-checkout-lib": "static-1.561",
  "cssUtils": "static-1.1062",
  "customer-data-objects": "static-1.8135",
  "FireAlarmUi": "static-1.4827",
  "foundations-assets": "static-1.5327",
  "foundations-theming": "static-1.4927",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12241",
  "icons": "static-2.700",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3327",
  "property-translator": "static-1.5820",
  "quartz-config": "static-1.1397",
  "quartz-core": "static-1.6838",
  "quartz-i18n": "static-1.1294",
  "quartz-routing": "static-1.1049",
  "quartz-tracking": "static-1.998",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17175",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10811",
  "rpc-client-utils": "static-1.5113",
  "sanitize-text": "static-1.8597",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.514",
  "superstore": "static-1.5199",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11586",
  "ui-images": "static-2.1270",
  "usage-tracker-core": "static-1.7613",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3896",
  "quartz-webpack": "static-1.3843",
  "bend-plugin-quartz-routing": "static-1.697",
  "bender-build-tools": "static-1.3518",
  "crm_universal": "static-1.22672",
  "customer-data-email": "static-1.18600",
  "customer-data-ui-utilities": "static-1.10274",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8359",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8204",
  "quick-fetch": "static-1.4209",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4961",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2643",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9866",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.97",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3009",
  "ui-fonts": "static-1.1196",
  "HeadJS": "static-2.817",
  "hs-test-utils-bend-plugin": "static-1.3589",
  "msw": "static-1.102",
  "msw-config": "static-1.25",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.379",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4749",
  "foundations-components-test-utils": "static-1.6175",
  "ui-addon-draggable": "static-3.5188",
  "commerce-billing-lib": "static-1.20473",
  "commerce-shared-components-lib": "static-1.19506",
  "commerce-tools-ui-lib": "static-1.11265",
  "crm-message-bus": "static-1.44034",
  "customer-data-objects-ui-components": "static-1.13471",
  "customer-data-properties": "static-1.52951",
  "growth-payments-core": "static-1.26441",
  "ui-addon-iframeable": "static-1.9517",
  "usage-tracker": "static-1.7763",
  "usage-tracker-container": "static-1.7753",
  "sassPrefix": "static-1.330",
  "inbound-db-properties-service-client": "static-1.4129",
  "foundations-theming-base": "static-1.3912",
  "bend-plugin-foundations-theming": "static-1.3410",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.230",
  "hub-http-janus": "static-1.903",
  "hubspotter-http": "static-1.4953",
  "mobile-manifest-mixins": "static-1.601",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.605",
  "quartz-auth": "static-1.1294",
  "quartz-head": "static-1.1284",
  "quartz-test": "static-1.1294",
  "trellis-components": "static-1.3028",
  "usage-tracker-session-replay": "static-1.5449",
  "csstype": "static-1.50",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.523",
  "chirp-fetch": "static-1.2343",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4915",
  "FormUrlGenerator": "static-2.5157",
  "sequences-lib": "static-1.8720",
  "apollo-link-hub-http": "static-2.5028",
  "FileManagerCore": "static-1.40279",
  "FileManagerLib": "static-1.40420",
  "hubspot-apollo-client": "static-1.5320",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.697",
  "timezone-utils": "static-2.5672",
  "ui-gdpr-components": "static-1.10651",
  "react-dnd-compat": "static-1.5051",
  "stylex-utils": "static-1.169",
  "trellis-theming": "static-1.1431",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2925",
  "hs-resources": "static-1.634",
  "pulse": "static-1.1083",
  "utility-belt": "static-1.2977",
  "zustand": "static-1.88",
  "batch-promise": "static-1.1988",
  "customer-data-associations": "static-1.7775",
  "customer-data-property-utils": "static-1.8488",
  "customer-data-tracking": "static-1.7313",
  "framework-data-schema-resolvers": "static-1.7335",
  "framework-data-table": "static-2.12784",
  "object-builder-ui-client": "static-1.49977",
  "payments-enrollment-embed-lib": "static-1.24137",
  "stripe-embedded-components": "static-1.8190",
  "ui-addon-opt": "static-4.8829",
  "ai-components-ui-library": "static-1.9959",
  "customer-data-rte": "static-1.33843",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24780",
  "growth-onboarding-confetti": "static-1.3502",
  "growth-onboarding-empty-states": "static-1.6479",
  "hubspot-prosemirror": "static-1.19225",
  "InboxConnectUtils": "static-4.15787",
  "payment-link-components": "static-1.24382",
  "payments-post-enroll-local-storage-lib": "static-1.5543",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39123",
  "react-colorpicker": "static-2.10652",
  "ui-addon-upgrades": "static-9.18528",
  "ui-addon-video-player": "static-1.9065",
  "user-context": "static-1.5494",
  "restore-request-side-panel-lib": "static-1.1962",
  "atom": "static-1.5518",
  "reference-resolvers": "static-1.8621",
  "calling-global-api": "static-1.66087",
  "calling-internal-common": "static-1.31765",
  "calling-lifecycle-internal": "static-1.67469",
  "calling-lifecycle-messages": "static-1.59762",
  "commerce-products-lib": "static-1.10822",
  "conditional-properties-service-client": "static-1.4098",
  "crm-index-visualization-core": "static-1.4713",
  "crm-links": "static-1.6748",
  "crm-pipelines-api-client-types": "static-1.4429",
  "customer-data-properties-shared-msw-handlers": "static-1.10173",
  "external-options-client-types": "static-1.4427",
  "formula-editor": "static-1.14962",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3756",
  "inbounddb-objects-service-types": "static-1.4508",
  "meetings-icalendar-utils-lib": "static-1.1078",
  "multi-currency-client-types": "static-1.3994",
  "pipeline-validation-client-types": "static-1.4266",
  "property-value-citations": "static-1.3565",
  "reference-resolvers-lite": "static-1.8549",
  "smart-data-capture-core": "static-1.413",
  "smart-property-lib": "static-1.8571",
  "tiered-pricing": "static-1.2176",
  "topics-actions-lib": "static-1.619",
  "trellis-ext-i18n": "static-1.1333",
  "trial-components-library": "static-1.14323",
  "ui-addon-form-validation": "static-1.11342",
  "laboratory-lib": "static-3.7591",
  "onboarding-scopes": "static-1.6893",
  "seat-types-lib": "static-1.988",
  "magpie-lib": "static-1.5879",
  "navigation-messaging": "static-1.8426",
  "ts-schema": "static-1.4379",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.141",
  "hub-http-shared-msw-handlers": "static-1.10846",
  "hubspotter-http-shared-msw-handlers": "static-1.10844",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8577",
  "audio-components": "static-1.6521",
  "breeze-artifacts-sdk": "static-1.782",
  "ContentUtils": "static-1.69402",
  "copilot-toolkit": "static-1.12088",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30007",
  "FileManagerImages": "static-1.37931",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4582",
  "ui-universal-auth": "static-1.9663",
  "urlinator": "static-1.4956",
  "video-components": "static-1.14375",
  "video-data-lib": "static-1.36031",
  "video-embed": "static-1.36865",
  "hubspot-apollo-cache": "static-1.779",
  "event-emitter": "static-1.1401",
  "fdsr-migration-layer": "static-1.454",
  "framework-builder-read-service-client": "static-1.4311",
  "bend-plugin-pulse": "static-1.586",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7240",
  "persist-promise": "static-1.4145",
  "customer-data-reference-ui-components": "static-1.13608",
  "reporting-data": "static-1.69256",
  "tasks-actions-lib": "static-1.380",
  "purchase-motions-components": "static-1.6590",
  "growth-onboarding-feedback-components": "static-1.7023",
  "growth-onboarding-reliability": "static-1.5522",
  "marketplace-ui-apps-core": "static-1.19525",
  "onboarding-tours": "static-1.17346",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23629",
  "content-assistance-lib": "static-1.8372",
  "draft-content-plugins": "static-1.29100",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22304",
  "rich-text-lib": "static-1.20501",
  "breeze-engine-lib": "static-1.2055",
  "poll-commands": "static-1.3916",
  "video-components-external": "static-1.12373",
  "trellis-story-utils": "static-1.4942",
  "ui-addon-react-router-dom": "static-1.9968",
  "content-media-capture": "static-1.5726",
  "knowledge-content-types": "static-1.8728",
  "ui-addon-emoji-picker": "static-1.10306",
  "ui-business-units-lib": "static-1.9537",
  "ui-shepherd-react": "static-3.10717",
  "hub-http-contrib": "static-1.3470",
  "ui-addon-sales-email": "static-1.5643",
  "commerce-tours-lib": "static-1.6812",
  "getting-started-shared-tasks": "static-1.19504",
  "sales-checkout-service-client": "static-1.3965",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18622",
  "onboarding-tours-utils": "static-1.1413",
  "calling-error-reporting": "static-1.31772",
  "shared-worker-versioning": "static-1.11482",
  "calling-usage-tracker": "static-1.6975",
  "voice-sms-access-library": "static-1.2370",
  "conversations-skeleton-state": "static-1.7603",
  "commerce-permissions": "static-1.1223",
  "products-iframe-lib": "static-1.8841",
  "products-ui-components-shared-msw-handlers": "static-1.11228",
  "crm-index-associations-lib": "static-1.6890",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10929",
  "sales-views-client-types": "static-1.4698",
  "location-customization-utils-lib": "static-1.10360",
  "bark-lib": "static-1.16972",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6331",
  "react-codemirror": "static-1.11081",
  "data-agent-kit": "static-1.850",
  "data-agent-test-utils": "static-1.394",
  "data-agent-utils": "static-1.863",
  "data-token-picker": "static-1.17078",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4199",
  "policy-lib": "static-1.7249",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10992",
  "embedded-academy-lib": "static-1.15922",
  "hubs-service-types": "static-1.1706",
  "navigation-components": "static-1.19099",
  "nudge-client-utils": "static-1.3360",
  "purchase-motions-api": "static-1.6593",
  "signup-constants": "static-1.19877",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5339",
  "reactive-lib": "static-1.1164",
  "simple-logging-lib": "static-1.3493",
  "nav-meta": "static-1.30736",
  "cms-field-types": "static-1.5254",
  "content-icons-ui": "static-1.2425",
  "integrations-lib": "static-1.17334",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1459",
  "social-insights-client-types": "static-1.22876",
  "outpost": "static-1.4574",
  "reporting-client-types": "static-1.2805",
  "signup-ui-url-generator": "static-2.8498",
  "developer-experience-shared-components": "static-1.10980",
  "immutable-less": "static-1.5093",
  "marketplace-ui-client-types": "static-1.18400",
  "marketplace-ui-common": "static-1.20993",
  "ui-addon-integrations-directory-panel": "static-2.8395",
  "ui-extensibility-client-types": "static-1.4357",
  "growth-data-modal": "static-1.6083",
  "growth-onboarding-next-action-utils": "static-1.2927",
  "onboarding-tours-client": "static-1.5561",
  "ui-shepherd-tracker": "static-1.8098",
  "ui-coaching-tips": "static-1.29542",
  "breeze-engine-chat-components": "static-1.1033",
  "breeze-engine-core": "static-1.1333",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13530",
  "content-media-compositions": "static-2.17537",
  "media-bridge-lib": "static-1.19590",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4867",
  "calling-orchestration-schema": "static-1.37147",
  "crm-record-cards-service-types": "static-1.3851",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16611",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.182",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15382",
  "nest": "static-1.675",
  "nudge-custom-function-registry": "static-1.3117",
  "nudge-renderer-utils": "static-1.3436",
  "whisper-core-api": "static-1.7582",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14749",
  "integrations-tracking-lib": "static-1.6056",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1177",
  "apps-service-types": "static-1.4087",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8531",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1491",
  "onboarding-data-sync-lib": "static-1.2788",
  "growth-onboarding-next-action-components": "static-1.2955",
  "user-context-client": "static-1.4950",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4133",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4834",
  "trellis-ecosystem": "static-1.7800",
  "wootric-nps": "static-1.7281",
  "universal-page-editor-lib": "static-1.3450",
  "adobe-sign-auth-lib": "static-1.707",
  "ads-unified-auth-lib": "static-1.1836",
  "custom-vendor-connection-lib": "static-1.227",
  "google-sheets-integration-lib": "static-1.1273",
  "microsoft-drive-auth-lib": "static-1.433",
  "slack-ui-library": "static-1.10839",
  "surveymonkey-integration-lib": "static-1.804",
  "settings-ui-lib": "static-1.12970",
  "simple-data-table": "static-1.3768",
  "meetings-connect-utils-lib": "static-1.8057"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28638",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1985",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.508",
  "crm_data": "/crm_data/static-4.93136",
  "data-fetching-client": "/data-fetching-client/static-1.10081",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8692",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1717",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6033",
  "hs-test-utils": "/hs-test-utils/static-1.8478",
  "hub-http": "/hub-http/static-1.6650",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11934",
  "I18n": "/I18n/static-7.1700",
  "jasmine-runner": "/jasmine-runner/static-1.6891",
  "quartz": "/quartz/static-1.7619",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5640",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6071",
  "UIComponents": "/UIComponents/static-3.8880",
  "usage-tracker-public": "/usage-tracker-public/static-1.7574",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38034",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.561",
  "cssUtils": "/cssUtils/static-1.1062",
  "customer-data-objects": "/customer-data-objects/static-1.8135",
  "FireAlarmUi": "/FireAlarmUi/static-1.4827",
  "foundations-assets": "/foundations-assets/static-1.5327",
  "foundations-theming": "/foundations-theming/static-1.4927",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12241",
  "icons": "/icons/static-2.700",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3327",
  "property-translator": "/property-translator/static-1.5820",
  "quartz-config": "/quartz-config/static-1.1397",
  "quartz-core": "/quartz-core/static-1.6838",
  "quartz-i18n": "/quartz-i18n/static-1.1294",
  "quartz-routing": "/quartz-routing/static-1.1049",
  "quartz-tracking": "/quartz-tracking/static-1.998",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17175",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10811",
  "rpc-client-utils": "/rpc-client-utils/static-1.5113",
  "sanitize-text": "/sanitize-text/static-1.8597",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "superstore": "/superstore/static-1.5199",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11586",
  "ui-images": "/ui-images/static-2.1270",
  "usage-tracker-core": "/usage-tracker-core/static-1.7613",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3896",
  "quartz-webpack": "/quartz-webpack/static-1.3843",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.697",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "crm_universal": "/crm_universal/static-1.22672",
  "customer-data-email": "/customer-data-email/static-1.18600",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10274",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8359",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8204",
  "quick-fetch": "/quick-fetch/static-1.4209",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4961",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2643",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9866",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.97",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3009",
  "ui-fonts": "/ui-fonts/static-1.1196",
  "HeadJS": "/HeadJS/static-2.817",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3589",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.25",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.379",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4749",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6175",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5188",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20473",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19506",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11265",
  "crm-message-bus": "/crm-message-bus/static-1.44034",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13471",
  "customer-data-properties": "/customer-data-properties/static-1.52951",
  "growth-payments-core": "/growth-payments-core/static-1.26441",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9517",
  "usage-tracker": "/usage-tracker/static-1.7763",
  "usage-tracker-container": "/usage-tracker-container/static-1.7753",
  "sassPrefix": "/sassPrefix/static-1.330",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4129",
  "foundations-theming-base": "/foundations-theming-base/static-1.3912",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3410",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.230",
  "hub-http-janus": "/hub-http-janus/static-1.903",
  "hubspotter-http": "/hubspotter-http/static-1.4953",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.605",
  "quartz-auth": "/quartz-auth/static-1.1294",
  "quartz-head": "/quartz-head/static-1.1284",
  "quartz-test": "/quartz-test/static-1.1294",
  "trellis-components": "/trellis-components/static-1.3028",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5449",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.523",
  "chirp-fetch": "/chirp-fetch/static-1.2343",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4915",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5157",
  "sequences-lib": "/sequences-lib/static-1.8720",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5028",
  "FileManagerCore": "/FileManagerCore/static-1.40279",
  "FileManagerLib": "/FileManagerLib/static-1.40420",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5320",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.697",
  "timezone-utils": "/timezone-utils/static-2.5672",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "react-dnd-compat": "/react-dnd-compat/static-1.5051",
  "stylex-utils": "/stylex-utils/static-1.169",
  "trellis-theming": "/trellis-theming/static-1.1431",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2925",
  "hs-resources": "/hs-resources/static-1.634",
  "pulse": "/pulse/static-1.1083",
  "utility-belt": "/utility-belt/static-1.2977",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.1988",
  "customer-data-associations": "/customer-data-associations/static-1.7775",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8488",
  "customer-data-tracking": "/customer-data-tracking/static-1.7313",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7335",
  "framework-data-table": "/framework-data-table/static-2.12784",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49977",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24137",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8190",
  "ui-addon-opt": "/ui-addon-opt/static-4.8829",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9959",
  "customer-data-rte": "/customer-data-rte/static-1.33843",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24780",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3502",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6479",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19225",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15787",
  "payment-link-components": "/payment-link-components/static-1.24382",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5543",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39123",
  "react-colorpicker": "/react-colorpicker/static-2.10652",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18528",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9065",
  "user-context": "/user-context/static-1.5494",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1962",
  "atom": "/atom/static-1.5518",
  "reference-resolvers": "/reference-resolvers/static-1.8621",
  "calling-global-api": "/calling-global-api/static-1.66087",
  "calling-internal-common": "/calling-internal-common/static-1.31765",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67469",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59762",
  "commerce-products-lib": "/commerce-products-lib/static-1.10822",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4098",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4713",
  "crm-links": "/crm-links/static-1.6748",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4429",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10173",
  "external-options-client-types": "/external-options-client-types/static-1.4427",
  "formula-editor": "/formula-editor/static-1.14962",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3756",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4508",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1078",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3994",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4266",
  "property-value-citations": "/property-value-citations/static-1.3565",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8549",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.413",
  "smart-property-lib": "/smart-property-lib/static-1.8571",
  "tiered-pricing": "/tiered-pricing/static-1.2176",
  "topics-actions-lib": "/topics-actions-lib/static-1.619",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1333",
  "trial-components-library": "/trial-components-library/static-1.14323",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11342",
  "laboratory-lib": "/laboratory-lib/static-3.7591",
  "onboarding-scopes": "/onboarding-scopes/static-1.6893",
  "seat-types-lib": "/seat-types-lib/static-1.988",
  "magpie-lib": "/magpie-lib/static-1.5879",
  "navigation-messaging": "/navigation-messaging/static-1.8426",
  "ts-schema": "/ts-schema/static-1.4379",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.141",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10846",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10844",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8577",
  "audio-components": "/audio-components/static-1.6521",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.782",
  "ContentUtils": "/ContentUtils/static-1.69402",
  "copilot-toolkit": "/copilot-toolkit/static-1.12088",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30007",
  "FileManagerImages": "/FileManagerImages/static-1.37931",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4582",
  "ui-universal-auth": "/ui-universal-auth/static-1.9663",
  "urlinator": "/urlinator/static-1.4956",
  "video-components": "/video-components/static-1.14375",
  "video-data-lib": "/video-data-lib/static-1.36031",
  "video-embed": "/video-embed/static-1.36865",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.779",
  "event-emitter": "/event-emitter/static-1.1401",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.454",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4311",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.586",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7240",
  "persist-promise": "/persist-promise/static-1.4145",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13608",
  "reporting-data": "/reporting-data/static-1.69256",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.380",
  "purchase-motions-components": "/purchase-motions-components/static-1.6590",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7023",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5522",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19525",
  "onboarding-tours": "/onboarding-tours/static-1.17346",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23629",
  "content-assistance-lib": "/content-assistance-lib/static-1.8372",
  "draft-content-plugins": "/draft-content-plugins/static-1.29100",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22304",
  "rich-text-lib": "/rich-text-lib/static-1.20501",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2055",
  "poll-commands": "/poll-commands/static-1.3916",
  "video-components-external": "/video-components-external/static-1.12373",
  "trellis-story-utils": "/trellis-story-utils/static-1.4942",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9968",
  "content-media-capture": "/content-media-capture/static-1.5726",
  "knowledge-content-types": "/knowledge-content-types/static-1.8728",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10306",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9537",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10717",
  "hub-http-contrib": "/hub-http-contrib/static-1.3470",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5643",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6812",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19504",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3965",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18622",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1413",
  "calling-error-reporting": "/calling-error-reporting/static-1.31772",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11482",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6975",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2370",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "commerce-permissions": "/commerce-permissions/static-1.1223",
  "products-iframe-lib": "/products-iframe-lib/static-1.8841",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11228",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6890",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10929",
  "sales-views-client-types": "/sales-views-client-types/static-1.4698",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10360",
  "bark-lib": "/bark-lib/static-1.16972",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6331",
  "react-codemirror": "/react-codemirror/static-1.11081",
  "data-agent-kit": "/data-agent-kit/static-1.850",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.394",
  "data-agent-utils": "/data-agent-utils/static-1.863",
  "data-token-picker": "/data-token-picker/static-1.17078",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4199",
  "policy-lib": "/policy-lib/static-1.7249",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10992",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15922",
  "hubs-service-types": "/hubs-service-types/static-1.1706",
  "navigation-components": "/navigation-components/static-1.19099",
  "nudge-client-utils": "/nudge-client-utils/static-1.3360",
  "purchase-motions-api": "/purchase-motions-api/static-1.6593",
  "signup-constants": "/signup-constants/static-1.19877",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5339",
  "reactive-lib": "/reactive-lib/static-1.1164",
  "simple-logging-lib": "/simple-logging-lib/static-1.3493",
  "nav-meta": "/nav-meta/static-1.30736",
  "cms-field-types": "/cms-field-types/static-1.5254",
  "content-icons-ui": "/content-icons-ui/static-1.2425",
  "integrations-lib": "/integrations-lib/static-1.17334",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1459",
  "social-insights-client-types": "/social-insights-client-types/static-1.22876",
  "outpost": "/outpost/static-1.4574",
  "reporting-client-types": "/reporting-client-types/static-1.2805",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8498",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10980",
  "immutable-less": "/immutable-less/static-1.5093",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18400",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20993",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8395",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4357",
  "growth-data-modal": "/growth-data-modal/static-1.6083",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2927",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5561",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8098",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29542",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1033",
  "breeze-engine-core": "/breeze-engine-core/static-1.1333",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13530",
  "content-media-compositions": "/content-media-compositions/static-2.17537",
  "media-bridge-lib": "/media-bridge-lib/static-1.19590",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4867",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37147",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3851",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16611",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.182",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15382",
  "nest": "/nest/static-1.675",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3117",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3436",
  "whisper-core-api": "/whisper-core-api/static-1.7582",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14749",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6056",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1177",
  "apps-service-types": "/apps-service-types/static-1.4087",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8531",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1491",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2788",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2955",
  "user-context-client": "/user-context-client/static-1.4950",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4133",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4834",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7800",
  "wootric-nps": "/wootric-nps/static-1.7281",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3450",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.707",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1836",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.227",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1273",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.433",
  "slack-ui-library": "/slack-ui-library/static-1.10839",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.804",
  "settings-ui-lib": "/settings-ui-lib/static-1.12970",
  "simple-data-table": "/simple-data-table/static-1.3768",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8057"
}
};
